/**
 * StagePieces.module.scss — the coda thumb, the look door and the coda door (board
 * `TenthFrame.dc.html`: `.thumb.ghost`, `.door`). `--stage-*` variables only; the dashed accent is
 * `core/wall/ui/Ghost.module.scss`'s mix.
 */

/* ── The coda thumb ──────────────────────────────────────────────────────────── */

.codaThumb {
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, var(--stage-accent) 4%, transparent);
    border: 1px dashed color-mix(in srgb, var(--stage-accent) 55%, transparent);
    cursor: pointer;
    padding: 0;

    &:focus-visible {
        outline: 2px solid var(--stage-accent);
        outline-offset: 2px;
    }
}

.codaThumbOn {
    border: 2px dashed var(--stage-accent);
    background: color-mix(in srgb, var(--stage-accent) 10%, transparent);
}

.codaThumbPen {
    width: 13px;
    height: 13px;
    display: block;
    color: var(--stage-accent);

    svg {
        width: 100%;
        height: 100%;
        display: block;
    }
}

/* ── The doors ───────────────────────────────────────────────────────────────── */

.doorPen {
    width: 14px;
    height: 14px;
    flex: none;
    display: block;

    svg {
        width: 100%;
        height: 100%;
        display: block;
    }
}

/* On the look, bottom-right, above the pager zones (the house's zones sit at z-index 5). */
.lookDoor {
    position: absolute;
    bottom: 12px;
    right: 12px;
    z-index: 7;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13px;
    line-height: 1.2;
    color: var(--stage-accent);
    text-decoration: none;
    background: color-mix(in srgb, var(--stage-ground) 72%, transparent);
    border: 1px solid color-mix(in srgb, var(--stage-accent) 55%, transparent);
    border-radius: 9999px;
    padding: 6px 12px 6px 10px;
    backdrop-filter: blur(6px);

    &:hover {
        background: color-mix(in srgb, var(--stage-ground) 88%, transparent);
    }

    &:focus-visible {
        outline: 2px solid var(--stage-accent);
        outline-offset: 2px;
    }
}

/* In the aside: the ghost's dashed accent as a full-width button, accent words, never filled —
   the coda holds the house's one filled verb. */
.codaDoor {
    appearance: none;
    font: inherit;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 8px 0 0;
    padding: 12px 14px;
    font-size: 14px;
    line-height: 1.3;
    color: var(--stage-accent);
    background: color-mix(in srgb, var(--stage-accent) 4%, transparent);
    border: 1px dashed color-mix(in srgb, var(--stage-accent) 55%, transparent);
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
    transition: border-color 150ms ease;

    /* The ghost materialises: the dashed line turns solid, the ground stays. A deeper accent fill
       read as a muddy khaki box — the faded-verb look the coda retired (operator, 2026-09-23). */
    &:hover {
        border-style: solid;
        border-color: var(--stage-accent);
    }

    &:focus-visible {
        outline: 2px solid var(--stage-accent);
        outline-offset: 2px;
    }
}
